export const MAXIMUM_NUMBER_OF_TODO_REQUEST_TO_DISPLAY = 9;
